import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wrong",
  "use": "icon-wrong-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol viewBox=\"0 0 11 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-wrong\">\r\n<path d=\"M1 1.14648L9.79297 9.64648\" stroke=\"#FC5A5A\" stroke-width=\"2\" stroke-linecap=\"round\" />\r\n<path d=\"M9.79297 1.14648L1.29297 9.64648\" stroke=\"#FC5A5A\" stroke-width=\"2\" stroke-linecap=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol